import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchGitPullRequest } from '@/services/git/api';
import type { GitPullRequestDetail } from '@/services/git/types';
import { useAuthStoreV1 } from '@/stores/authStore_v1';

export function useGitPullRequest(
  repoFullName: string | null | undefined,
  number: number | null | undefined,
): UseQueryResult<GitPullRequestDetail | null, Error> {
  const token = useAuthStoreV1((s) => s.token);
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id);

  return useQuery({
    queryKey: ['gitPullRequest', orgId, repoFullName, number],
    queryFn: () => fetchGitPullRequest(orgId!, repoFullName!, number!),
    enabled: !!token && !!orgId && !!repoFullName && number != null,
    staleTime: 30 * 1000,
    refetchOnWindowFocus: false,
  });
}
